export const MIXPANEL_ACTIVE_NOW = 'Active Now';
export const MIXPANEL_ACTIVE_SUBSCRIPTION_FOUND_POPUP =
  'Active Subscription Link by Mobile';
export const MIXPANEL_ACTUAL_COST = 'Actual Cost';
export const MIXPANEL_ADD_TO_HOME_SCREEN = 'Add To Home Screen';
export const MIXPANEL_ADYEN = 'Adyen';
export const MIXPANEL_AD_ID = 'Ad id';
export const MIXPANEL_AD_CAMPAIGN_ID = 'Ad Campaign ID';
export const MIXPANEL_AD_CREATIVE_ID = 'Ad Creative ID';
export const MIXPANEL_AD_SIZE = 'Ad size';
export const MIXPANEL_AD_LOCATION = 'Ad Location';
export const MIXPANEL_AD_ISEMPTY = 'Ad isEmpty';
export const MIXPANEL_ADD_SHORTCUT = 'Add shortcut';
export const MIXPANEL_AGE = 'Age';
export const MIXPANEL_AMAZON_PAY = 'Amagon Pay';
export const MIXPANEL_APPLE = 'Apple';
export const MIXPANEL_APPLE_REGISTER = 'appleRegister';
export const MIXPANEL_APPLE_PLAY_STORE = 'Apple Play Store';
export const MIXPANEL_APP_DOWNLOAD = 'App Download';
export const MIXPANEL_ASSETTYPE_CONSUMPTION_PAGE = 'Assettype_Consumption Page';
export const MIXPANEL_AUDIO_LANGUAGE = 'Audio Language';
export const MIXPANEL_AUTHENTICATE_DEVICE = 'Authenticate device';
export const MIXPANEL_AVOD = 'AVoD';
export const MIXPANEL_AVOD_OR_SVOD_CONTENT = 'AVoD/SVoD Content';
export const MIXPANEL_BACK = 'Back';
export const MIXPANEL_BANNER = 'Banner';
export const MIXPANEL_BACK_TO_TOP = 'Back to Top';
export const MIXPANEL_BANNER_OR_RAIL = 'Banner/Rail';
export const MIXPANEL_BEFORE_TV_LOGIN_SUBSCRIBE = 'before_tv_login_subscribe';
export const MIXPANEL_BEFORE_TV_SUBSCRIBE = 'before_tv_subscribe';
export const MIXPANEL_BENEFIT = 'Benefit <id>';
export const MIXPANEL_BILLING_COUNTRY = 'Billing Country';
export const MIXPANEL_BILLING_STATE = 'Billing State';
export const MIXPANEL_BREADCRUMB = 'Breadcrumb';
export const MIXPANEL_BROWSE_ALL_PACKS = 'Browse All Packs';
export const MIXPANEL_BROWSER_UPDATE_POPUP = 'Browser update popup';
export const MIXPANEL_BUTTON = 'Button';
export const MIXPANEL_BUTTON_TYPE = 'Button Type';
export const MIXPANEL_BUY_PREMIUM = 'Buy Premium';
export const MIXPANEL_CANCELLATION_REASON = 'Cancellation Reason';
export const MIXPANEL_CAROUSAL_ID = 'Carousal ID';
export const MIXPANEL_CAROUSAL_NAME = 'Carousal Name';
export const MIXPANEL_CELL = 'Cell';
export const MIXPANEL_CHANGE_NUMBER = 'Change Number';
export const MIXPANEL_CHANNEL_NAME = 'Channel Name';
export const MIXPANEL_CHARACTERS = 'Characters';
export const MIXPANEL_CHANGE_PASSWORD = 'Change Password';
export const MIXPANEL_CLUB_CONTENT = 'Club';
export const MIXPANEL_PRE_ROLL_BUY_PLAN = 'Pre-roll Buy Plan';
export const MIXPANEL_COHORT_ID = 'Cohort_ID';
export const MIXPANEL_COHORT_DISCOUNT_PERCENT = 'Cohort Discount%';
export const MIXPANEL_COLLAPSE_DESCRIPTION = 'Collapse Description';
export const MIXPANEL_CONFIRM_SUBSCRIPTION_CANCEL =
  'confirm_subscription_cancel';
export const MIXPANEL_CONSUMPTION_CONTENT_LANGUAGE_UPDATE =
  'consumption_content_language_update';
export const MIXPANEL_CONSUMPTION_SUBSCRIBE = 'consumption_subscribe';
export const MIXPANEL_CONSUMPTION_LOGIN_SUBSCRIBE =
  'consumption_login_subscribe';
export const MIXPANEL_CONTENT = 'Content';
export const MIXPANEL_CONTENT_ID = 'Content ID';
export const MIXPANEL_CONTENT_DURATION = 'Content Duration';
export const MIXPANEL_CONTENT_NAME = 'Content Name';
export const MIXPANEL_CONTENT_ORIGIAL_LANGUAGE = 'Content Original Language';
export const MIXPANEL_CONTENT_SPECIFICATION = 'Content Specification';
export const MIXPANEL_CONTENT_TYPE = 'Content Type';
export const MIXPANEL_CONTENT_BILLING_TYPE = 'Content Billing Type';
export const MIXPANEL_CONTINUE = 'Continue';
export const MIXPANEL_COUNTER = 'Counter';
export const MIXPANEL_COUPON_CODE = 'Coupon_Code';
export const MIXPANEL_COST = 'Cost';
export const MIXPANEL_CREDIT_CARD = 'Credit Card';
export const MIXPANEL_CARD = 'Card';
export const MIXPANEL_CARD_NAME = 'Card Name';
export const MIXPANEL_CARD_RANK = 'Card Rank';
export const MIXPANEL_CROSS = 'Cross';
export const MIXPANEL_CTA = 'CTA';
export const MIXPANEL_CTAS = 'CTAs';
export const MIXPANEL_SHOP = 'Shop';
export const MIXPANEL_CROSS_COMMERCE = 'Cross Commerce';
export const MIXPANEL_CURRENT_SUBSCRIPTION = 'Current Subscription';
export const MIXPANEL_DEBIT_CARD = 'Debit Card';
export const MIXPANEL_DEKEY = 'dekey';
export const MIXPANEL_DESCRIPTION = 'Description';
export const MIXPANEL_DEVICE_CODE_EXPIRED = 'Device Code Expired';
export const MIXPANEL_DEVICE_CODE_NOT_FOUND = 'Device Code Not Found';
export const MIXPANEL_DIRECTION = 'Direction';
export const MIXPANEL_DATE_OF_BIRTH = 'DoB';
export const MIXPANEL_DAYS_TO_EXPIRY = 'Days To Expiry';
export const MIXPANEL_DOB = 'DOB';
export const MIXPANEL_DOWNLOAD_INVOICE = 'Download Invoice';
export const MIXPANEL_DROPDOWN = 'Dropdown';
export const MIXPANEL_EDIT_PROFILE = 'Edit Profile';
export const MIXPANEL_ELEMENT = 'Element';
export const MIXPANEL_EXPLORE_LOOKS = 'Explore Looks';
export const MIXPANEL_EXPLORE_NOW = 'Explore Now';
export const MIXPANEL_WISHLIST = 'Wishlist';
export const MIXPANEL_EMAIL = 'Email';
export const MIXPANEL_ENHANCED_SUBSCRIPTION = 'Enhanced subscription';
export const MIXPANEL_EPISODE_LIST = 'Episode list';
export const MIXPANEL_EPISODE_NO = 'Episode No';
export const MIXPANEL_EXPAND_DESCRIPTION = 'Expand Description';
export const MIXPANEL_EXPERIMENT_NAME = 'Experiment name';
export const MIXPANEL_VARIANT_NAME = 'Variant name';
export const MIXPANEL_SET_REMINDER = 'Set Reminder';
export const MIXPANEL_IS_EDUAURAA = 'isEduauraa';
export const MIXPANEL_REASON_SUBSCRIPTION_CANCEL = 'reason_subscription_cancel';
export const MIXPANEL_VARIANT_A = 'Variant A';
export const MIXPANEL_VARIANT_B = 'variant B';
export const MIXPANEL_HEADER_CTA = 'Header_CTA_Click';
export const MIXPANEL_SUBSCRIPTION_PACK_TOGGLE = 'Subscription_pack_toggle';
export const MIXPANEL_SHOP_PLAYER = 'Shop Player';
export const MIXPANEL_PACK_SELECT_CTA = 'Pack_selection_CTA';
export const MIXPANEL_SUBSCRIPTION_CTA_CLICK = 'Subscription_cta_click';
export const MIXPANEL_LOGIN_CTA_CLICK = 'Login_CTA1_click';
export const MIXPANEL_VERIFY_OTP_CTA = 'Verify_OTP_CTA';
export const MIXPANEL_TOP_SEARCH_VARIANT_ON = 'Top_Searches_Exp_Variant';
export const MIXPANEL_TOP_SEARCH_VARIANT_OFF = 'Top_Searches_Exp_Control';
export const MIXPANEL_CLEAR_ALL_SEARCH_WARNING = 'Clear all searches';
export const MIXPANEL_IS_PREMIUM_CONTENT = 'IsPremiumContent';
export const MIXPANEL_IS_LIVE = 'isLive';
export const MIXPANEL_CONTINUE_WATCHING = 'Continue Watching';
export const MIXPANEL_AUTO_PLAY = 'Auto-Play';
export const MIXPANEL_HOME = 'Home';
export const MIXPANEL_SHOW_DETAILS = 'show_detail';
export const MIXPANEL_EVENTS_TYPE_OF_SUBSCRIPTION = 'Type of subscription';
export const MIXPANEL_EVENTS_ADD_TO_WATCHLIST = 'Add To Watchlist';
export const MIXPANEL_EVENTS_AD_BLOCKER_DETECTED = 'Ad Blocker Detected';
export const MIXPANEL_EVENTS_AD_BANNER_IMPRESSION = 'Ad Banner Impression';
export const MIXPANEL_EVENTS_BELLY_UNIT_CTA = 'Belly Unit CTAs';
export const MIXPANEL_EVENTS_CANCEL_SUBSCRIPTION_RENEWAL =
  'Cancel Subscription Renewal';
export const MIXPANEL_EVENTS_CAROUSAL_BANNER_CLICK = 'Carousal Banner Click';
export const MIXPANEL_EVENTS_CAROUSAL_BANNER_SWIPE = 'Carousal Banner Swipe';
export const MIXPANEL_EVENTS_CAROUSAL_BANNER_CTA = 'Carousal Banner CTAs';
export const MIXPANEL_EVENTS_CHANGE_PASSWORD_RESULT = 'Change Password Result';
export const MIXPANEL_EVENTS_CHANGE_PASSWORD_STARTED =
  'Change Password Started';
export const MIXPANEL_EVENTS_CLEAR_SEARCH_HISTORY = 'Clear Search History';
export const MIXPANEL_EVENTS_COLLAPSE_DESCRIPTION = 'Collapse Description';
export const MIXPANEL_EVENTS_CODE_ENTERED = 'Code Entered';
export const MIXPANEL_EVENTS_CONTENT_BANNER_CLICK = 'Content Banner Click';
export const MIXPANEL_EVENTS_CONTENT_BANNER_IMPRESSION =
  'Content Banner Impression';
export const MIXPANEL_EVENTS_CONTENT_BUCKET_SWIPE = 'Content Bucket Swipe';
export const MIXPANEL_EVENTS_CONTENT_LANGUAGE_CHANGE =
  'Content Language Change';
export const MIXPANEL_EVENTS_CTAS = 'CTAs';
export const MIXPANEL_EVENTS_EDURACTAS = 'Eduauraasection_visited';
export const MIXPANEL_EVENTS_DEFAULT_SETTING_RESTORED =
  'Default Setting Restored';
export const MIXPANEL_EVENTS_DEVICE_AUTHENTICATION = 'Device Authentication';
export const MIXPANEL_EVENTS_EPISODE_LIST_CHOSEN = 'Episode list Chosen';
export const MIXPANEL_EVENTS_EXPAND_DESCRIPTION = 'Expand Description';
export const MIXPANEL_EVENTS_FILTER_APPLIED = 'Filter Applied';
export const MIXPANEL_EVENTS_SORTING_APPLIED = 'Sorting Applied';
export const MIXPANEL_EVENTS_DISPLAY_LANGUAGE_CHANGE =
  'Display Language Change';
export const MIXPANEL_EVENTS_EXPERIMENT_STARTED = '$experiment_started';
export const MIXPANEL_EVENTS_LOGIN_INITIATED = 'Login Initiated';
export const MIXPANEL_EVENTS_LOGIN_RESULT = 'Login Result';
export const MIXPANEL_EVENTS_LOGIN_SCREEN_DISPLAY = 'Login Screen Display';
export const MIXPANEL_EVENTS_LOGIN_USERNAME_ENTERED = 'Login Username Entered';
export const MIXPANEL_EVENTS_LOGIN_PASSWORD_ENTERED = 'Login Password Entered';
export const MIXPANEL_EVENTS_LOGOUT = 'Logout';
export const MIXPANEL_EVENTS_METHOD = 'Method';
export const MIXPANEL_EVENTS_PACK_TOGGLE = 'Pack Toggle';
export const MIXPANEL_EVENTS_PAGE_RAIL_IMPRESSION = 'Page Rail Impression';
export const MIXPANEL_EVENTS_PARENTAL_RESTRICTION = 'Parental_Restriction';
export const MIXPANEL_EVENTS_PARENTAL_OVERLAY_IMPRESSION =
  'Parental Overlay Impression';
export const MIXPANEL_EVENTS_PARENTAL_OVERLAY_RESULT =
  'Parental Overlay Result';
export const MIXPANEL_EVENTS_PASSWORD_RESET_RESULT = 'Password Reset Result';
export const MIXPANEL_EVENTS_PAYMENT_TAB_VIEW = 'Payment Tab View';
export const MIXPANEL_EVENTS_PLAYER_CTAS = 'Player CTAs';
export const MIXPANEL_EVENTS_POP_UP_CTAS = 'Popup CTAs';
export const MIXPANEL_EVENTS_POPUP_LAUNCH = 'Popup launch';
export const MIXPANEL_EVENTS_PREPAID_CODE_RESULT = 'Prepaid Code Result';
export const MIXPANEL_EVENTS_PROMO_CODE_RESULT = 'Promo Code Result';
export const MIXPANEL_EVENTS_PROFILE_UPDATE_RESULT = 'Profile Update Result';
export const MIXPANEL_EVENTS_PWA_APP_INSTALLATION_RESULT =
  'PWA installation result';
export const MIXPANEL_EVENTS_PWA_ELIGIBILITY = 'PWA Eligibility';
export const MIXPANEL_EVENTS_PWA_PROMPT_IMPRESSION = 'PWA prompt Impression';
export const MIXPANEL_EVENTS_PWA_PROPMT_CTAS = 'PWA prompt CTAs';
export const MIXPANEL_EVENTS_PAYMENT_SCREEN_IMPRESSION =
  'Payment Screen Impression';
export const MIXPANEL_EVENTS_RIBBON_IMPRESSION = 'Ribbon Impression';
export const MIXPANEL_EVENTS_RIBBON_CTAS = 'Ribbon CTAs';
export const MIXPANEL_EVENTS_REGISTRATION_DOB_ENTERED =
  'Registration DOB Entered';
export const MIXPANEL_EVENTS_REGISTRATION_GENDER_ENTERED =
  'Registration Gender Entered';
export const MIXPANEL_EVENTS_RECOMMENDED_RAIL_IMPRESSION =
  'Recommended Rail Impression';
export const MIXPANEL_EVENTS_REGISTRATION = 'Registration';
export const MIXPANEL_EVENTS_REGISTRATION_INITIATED = 'Registration Initiated';
export const MIXPANEL_EVENTS_REGISTRATION_RESULT = 'Registration Result';
export const MIXPANEL_EVENTS_REGISTRATION_SUCCESS = 'Registration Success';
export const MIXPANEL_EVENTS_REGISTRATION_USERNAME_ENTERED =
  'Registration Username Entered';
export const MIXPANEL_EVENTS_REGISTRATION_MOBILE_ENTERED =
  'Registration Mobile Entered';
export const MIXPANEL_EVENTS_REGISTRATION_OTP_ENTERED =
  'Registration OTP Entered';
export const MIXPANEL_EVENTS_REGISTRATION_PASSWORD_ENTERED =
  'Registration Password Entered';
export const MIXPANEL_EVENTS_REGISTER_SCREEN_DISPLAY =
  'Register Screen Display';
export const MIXPANEL_EVENTS_REMOVE_FROM_CONTINUE_WATCHING =
  'Remove from Continue Watching';
export const MIXPANEL_EVENTS_REMOVE_FROM_WATCHLIST = 'Remove From Watchlist';
export const MIXPANEL_EVENTS_RENTAL_PAGE_CTAS = 'Rental Page CTAs';
export const MIXPANEL_EVENTS_RENTAL_PURCHASE_CALL_INITIATED =
  'Rental Purchase Call Initiated';
export const MIXPANEL_EVENTS_RENTAL_PURCHASE_CALL_RETURNED =
  'Rental Purchase Call Returned';
export const MIXPANEL_EVENTS_SEARCH_BUTTON_CLICK = 'Search Button Click';
export const MIXPANEL_EVENTS_SEARCH_CANCELLED_EVENT = 'Search Cancelled';
export const MIXPANEL_EVENTS_SEARCH_EXECUTED = 'Search Executed';
export const MIXPANEL_EVENTS_FILTER_CLICKED = 'Search filter submit';
export const MIXPANEL_EVENTS_SEARCH_RESULT_CLICKED = 'Search Result Clicked';
export const MIXPANEL_EVENTS_SEARCH_STARTED = 'Search Started';
export const MIXPANEL_EVENTS_SEARCH_CLEARED = 'Search Cleared';
export const MIXPANEL_EVENTS_SCREEN_VIEW = 'Screen View';
export const MIXPANEL_EVENTS_SCREEN_NAME = 'Screen name';
export const MIXPANEL_EVENTS_SESSION = 'Session';
export const MIXPANEL_EVENTS_SET_REMINDER = 'Set Reminder';
export const MIXPANEL_EVENTS_SETTING_CHANGED = 'Setting Changed';
export const MIXPANEL_EVENTS_SHARE = 'Share';
export const MIXPANEL_EVENTS_SILENT_LOGIN = 'Silent Login';
export const MIXPANEL_EVENTS_SKIP_LOGIN = 'Skip Login';
export const MIXPANEL_EVENTS_SKIP_REGISTRATION = 'Skip Registration';
export const MIXPANEL_EVENTS_SUBSCRIPTION_CALL_INITIATED =
  'Subscription Call Initiated';
export const MIXPANEL_EVENTS_SUBSCRIPTION_CALL_RETURNED =
  'Subscription Call Returned';
export const MIXPANEL_EVENTS_PURCHASE_SUCCESSFUL = 'Purchase Successful';
export const MIXPANEL_EVENTS_SUBSCRIPTION_FAILURE = 'Subscription Failure';
export const MIXPANEL_EVENTS_SUBSCRIPTION_PAGE_VIEWED =
  'Subscription Page Viewed';
export const MIXPANEL_EVENTS_SUBSCRIPTION_PLAN_VIEWED =
  'Subscription Plan Viewed';
export const MIXPANEL_EVENTS_SUBSCRIPTION_POP_UP_VIEWED =
  'Subscription Pop up Viewed';
export const MIXPANEL_EVENTS_SUBSCRIPTION_SELECTED = 'Subscription Selected';
export const MIXPANEL_EVENTS_SUBSCRIPTION_TRANSACTION =
  'Subscription Transaction';
export const MIXPANEL_EVENTS_SSO_SUCCESS = 'SSO Success';
export const MIXPANEL_EVENTS_SSO_Failure = 'SSO Failure';
export const MIXPANEL_EVENTS_THUMBNAIL_CLICK = 'Thumbnail Click';
export const MIXPANEL_EVENTS_MEGA_MENU_THUMBNAIL_CLICK =
  'Megamenu Thumbnail Click';
export const MIXPANEL_EVENTS_TV_AUTHENTICATION_SCREEN_DISPLAY =
  'TV Authentication Screen Display';
export const MIXPANEL_EVENTS_TOAST_MESSAGE_IMPRESSION =
  'Toast Message Impression';
export const MIXPANEL_EVENTS_VIEW_MORE_SELECTED = 'View More Selected';
export const MIXPANEL_EVENTS_VIDEO_STREAMING_AUTOPLAY_CHANGED =
  'Video Streaming Autoplay Changed';
export const MIXPANEL_EVENTS_VIDEO_STREAMING_QUALITY_CHANGED =
  'Video Streaming Quality Changed';
export const MIXPANEL_EVENTS_TERMS_AND_PRIVACY_CHECKBOX =
  'Terms and Privacy consent checkbox';
export const MIXPANEL_EVENTS_STORIES_RAIL_IMPRESSION =
  'Stories Rail Impression';
export const MIXPANEL_EVENTS_WIFI_ELIGIBILITY = 'WiFi Eligibility';
export const MIXPANEL_EVENTS_RIBBON_CTA_EVENT = 'Ribbon CTAs';
export const MIXPANEL_EVENTS_WIDGET_CTA_EVENT = 'Widget CTAs';
export const MIXPANEL_EVENTS_WIDGET_IMPRESSION_EVENT = 'Widget Impression';
export const MIXPANEL_EVENTS_SHEERID_VERIFICATION_INITIATED =
  'SheerID Verification Initiated';
export const MIXPANEL_EVENTS_CAROUSAL_BANNER_IMPRESSION =
  'Carousel Banner Impression';
export const MIXPANEL_EVENTS_TAB_VIEW = 'Tab_view';
export const MIXPANEL_EVENTS_GENDER_CONFIRMATION = 'Gender Confirmation';
export const MIXPANEL_EVENTS_AGE_CONFIRMATION = 'Age Confirmation';
export const MIXPANEL_EVENTS_DOB_CONFIRMATION = 'DOB Confirmation';
export const MIXPANEL_EVENTS_LINKING = 'Link account success';
export const MIXPANEL_EVENTS_LINKING_INITIATED = 'Link Account Initiated';
export const MIXPANEL_EVENTS_REGISTER_SUCCESS = 'Registration success';
export const MIXPANEL_EVENTS_VOICE_ERROR_DISPLAYED = 'Voice error displayed';
export const MIXPANEL_EVENTS_INTERIM_SUBSCRIPTION_PAYMENT_SUCCESS =
  'Interim Subscription Payment Success';
export const MIXPANEL_EVENTS_EDUARAA_REDIRECTION = 'Eduaraa Redirection';
export const MIXPANEL_EVENTS_LOGIN_SUCCESS = 'loginSuccess';
export const MIXPANEL_EVENTS_SUBSCRIPTION_SUCCESS = 'subscriptionSuccess';
export const MIXPANEL_EVENTS_LOGIN_METHOD = 'loginMethod';
export const MIXPANEL_EVENTS_CARD_IMPRESSION = 'Card Impression';
export const MIXPANEL_FACEBOOK = 'Facebook';
export const MIXPANEL_FAILURE_REASON = 'Failure Reason';
export const MIXPANEL_FIELD_VALUE = 'field value';
export const MIXPANEL_FILTER = 'Filter';
export const MIXPANEL_FIRST_NAME = 'First Name';
export const MIXPANEL_FULL_NAME = 'Full Name';
export const MIXPANEL_FOOTER = 'Footer';
export const MIXPANEL_FORGOT_PASSWORD = 'Forgot Password?';
export const MIXPANEL_FORTUMO = 'Fortumo';
export const MIXPANEL_FREE_CONTENT = 'Free';
export const MIXPANEL_FREE_TRIAL_EXPIRY_DATE = 'Free Trial Expiry Date';
export const MIXPANEL_FREE_TRIAL_PACKAGE = 'Free Trial Package';
export const MIXPANEL_GENDER = 'Gender';
export const MIXPANEL_GENRE = 'Genre';
export const MIXPANEL_GIFT_CARD = 'Gift Card';
export const MIXPANEL_GOOGLE = 'Google';
export const MIXPANEL_GOOGLE_PLAY_STORE = 'Google Play Store';
export const MIXPANEL_GET_PREMIUM = 'Get Premium';
export const MIXPANEL_GUEST_ID = 'guest_id';
export const MIXPANEL_GO_BACK = 'Go Back';
export const MIXPANEL_HAMBURGER = 'Hamburger';
export const MIXPANEL_HAS_EDUAURAA = 'hasEduauraa';
export const MIXPANEL_HAS_RENTAL = 'HasRental';
export const MIXPANEL_HEADER = 'Header';
export const MIXPANEL_HORIZONTAL_INDEX = 'Horizontal Index';
export const MIXPANEL_IDENTITY = 'Identity';
export const MIXPANEL_IMAGE_URL = 'Image URL';
export const MIXPANEL_INSTAGRAM = 'Instagram';
export const MIXPANEL_INSTALL_PROMPT = 'Install Prompt';
export const MIXPANEL_IN_FEED = 'In-feed';
export const MIXPANEL_IS_PWA = 'isPWA';
export const MIXPANEL_IS_RECOMMENDED = 'isRecommended';
export const MIXPANEL_IS_RENTAL = 'isRental';
export const MIXPANEL_IS_TALAMOOS = 'isTalamoos';
export const MIXPANEL_IS_UPGRADE = 'isUpgrade';
export const MIXPANEL_LANDING_PAGE_NAME = 'Landing Page Name';
export const MIXPANEL_LAST_NAME = 'Last Name';
export const MIXPANEL_LATER = 'Later';
export const MIXPANEL_LATEST_SUBSCRIPTION_PACK = 'Latest Subscription Pack';
export const MIXPANEL_LATEST_SUBSCRIPTION_PACK_EXPIRY =
  'Latest Subscription Pack Expiry';
export const MIXPANEL_LEFT_ARROW = 'left-arrow';
export const MIXPANEL_LEFT = 'Left';
export const MIXPANEL_LINK = 'Link';
export const MIXPANEL_LOAD_TIME = 'Load Time';
export const MIXPANEL_LOGIN = 'Login';
export const MIXPANEL_LOGIN_SUBSCRIBE = 'login_subscribe';
export const MIXPANEL_LOGIN_REGISTRATION_SUCCESS = 'Login Registration Success';
export const MIXPANEL_LOGOUT = 'LOGOUT';
export const MIXPANEL_MANDATORY_REGISTRATION = 'Mandatory Registration';
export const MIXPANEL_MANDATORY = 'Mandatory';
export const MIXPANEL_MARKETING_LANDING_PAGE = 'Marketing Landing Page';
export const MIXPANEL_MEGA_MENU = 'Mega Menu';
export const MIXPANEL_MASTHEAD = 'Masthead';
export const MIXPANEL_METHOD = 'Method';
export const MIXPANEL_MINUTELY = 'Minutely';
export const MIXPANEL_MINUTES_TO_EXPIRY = 'Minutes to Expiry';
export const MIXPANEL_MISC = 'MISC';
export const MIXPANEL_MOBIKWIK = 'MobiKwik';
export const MIXPANEL_MOBILE = 'Mobile';
export const MIXPANEL_NAME = 'Name';
export const MIXPANEL_NATIVE = 'Native';
export const MIXPANEL_NETBANKING = 'Netbanking';
export const MIXPANEL_NEXT_EXPIRING_PACK = 'Next Expiring Pack';
export const MIXPANEL_NEXT_PACK_EXPIRY_DATE = 'Next Pack Expiry Date';
export const MIXPANEL_NEW_AUTOPLAY_SETTING = 'New Autoplay Setting';
export const MIXPANEL_NEW_APP_LANGUAGE = 'New App Language';
export const MIXPANEL_NEW_CONTENT_LANGUAGE = 'New Content Language';
export const MIXPANEL_NEW_SETTING_VALUE = 'New Setting Value';
export const MIXPANEL_NEW_VIDEO_STREAMING_QUALITY_SETTING =
  'New Video Streaming Quality Setting';
export const MIXPANEL_NO = 'No';
export const MIXPANEL_NOT_NOW = 'Not now';
export const MIXPANEL_NOT_AVAILABLE = 'N/A';
export const MIXPANEL_OFFLINE_TRACKING = 'Offline Tracking';
export const MIXPANEL_OFFLINE = 'offline';
export const MIXPANEL_ONLINE = 'offline';
export const MIXPANEL_OLD_AUTOPLAY_SETTING = 'Old Autoplay Setting';
export const MIXPANEL_OLD_APP_LANGUAGE = 'Old App Language';
export const MIXPANEL_OLD_CONTENT_LANGUAGE = 'Old Content Language';
export const MIXPANEL_OLD_SETTING_VALUE = 'Old Setting Value';
export const MIXPANEL_OLD_VIDEO_STREAMING_QUALITY_SETTING =
  'Old Video Streaming Quality Setting';
export const MIXPANEL_ONBOARDING_CONTENT_LANGUAGE =
  'Onboarding Content Language';
export const MIXPANEL_ONBOARDING_DISPLAY_LANGUAGE =
  'Onboarding Display Language';
export const MIXPANEL_ORDER_ID = 'Order ID';
export const MIXPANEL_OTP_SCREEN = 'OTP';
export const MIXPANEL_OTP_SCREEN_LOGIN = 'OTP to login';
export const MIXPANEL_PACK_DURATION = 'Pack Duration';
export const MIXPANEL_PACK_SELECTED = 'Pack Selected';
export const MIXPANEL_PAGE_NAME = 'Page Name';
export const MIXPANEL_PARENT_CONTROL_ACTIVATED = 'Parent Control Activated';
export const MIXPANEL_PARENT_CONTROL_DEACTIVATED = 'Parent Control Deactivated';
export const MIXPANEL_PARENT_CONTROL_PIN_RESET_STARTED =
  'Parent Control PIN Reset Started';
export const MIXPANEL_PARENT_CONTROL_PIN_RESET_COMPLETED =
  'Parent Control PIN Reset Completed';
export const MIXPANEL_PARENT_CONTROL_PIN_SET = 'Parent Control PIN Set';
export const MIXPANEL_PARENT_CONTROL_SETTING = 'Parent Control Setting';
export const MIXPANEL_PARTNER_NAME = 'Partner Name';
export const MIXPANEL_PASSWORD = 'Password';
export const MIXPANEL_PAYTM = 'PayTM';
export const MIXPANEL_PAYMENT_GATEWAY = 'Payment Gateway';
export const MIXPANEL_PAYMENT_METHOD = 'Payment Method';
export const MIXPANEL_PAYMENT_NOT_LINKED_POPUP =
  'Payment not linked to account';
export const MIXPANEL_PAYMENT_SUCCESS = 'Payment Success';
export const MIXPANEL_PAYMENT_SUCCESSFUL_POPUP = 'Payment Successful';
export const MIXPANEL_PAYPAL = 'PayPal';
export const MIXPANEL_PHONE = 'Phone';
export const MIXPANEL_PHONEPE = 'PhonePe';
export const MIXPANEL_PHOTO = 'Photo';
export const MIXPANEL_PLATFORM_NAME = 'Platform Name';
export const MIXPANEL_PLATFORM_SECTION = 'Platform Section';
export const MIXPANEL_PLAYER = 'Player';
export const MIXPANEL_POP_UP_NAME = 'PopUp Name';
export const MIXPANEL_POP_UP_TYPE = 'Pop Up Type';
export const MIXPANEL_POP_UP_GROUP = 'Pop Up Group';
export const MIXPANEL_POP_UP_NUDGE = 'Save 50%';
export const MIXPANEL_PREVIEW_STATUS = 'Preview Status';
export const MIXPANEL_PREMIUM_BENEFITS = 'Premium Benefits';
export const MIXPANEL_PREMIUM_CONTENT = 'Premium';
export const MIXPANEL_PRIVACY_POLICY = 'Privacy Policy';
export const MIXPANEL_PRODUCT_TYPE = 'Product';
export const MIXPANEL_PREPAID_TYPE = 'Prepaid';
export const MIXPANEL_PREPAID_CODE = 'Prepaid Code';
export const MIXPANEL_PROCEED = 'Proceed';
export const MIXPANEL_PROFILE = 'Profile';
export const MIXPANEL_PROFILE_ADDED = 'Profile Added';
export const MIXPANEL_PROFILE_DELETED = 'Profile Deleted';
export const MIXPANEL_PROFILE_SWITCHED = 'Profile Switched';
export const MIXPANEL_PROMO_CODE = 'Promo Code';
export const MIXPANEL_PROMO_CODE_TYPE = 'Promo Code Type';
export const MIXPANEL_PUBLISHING_DATE = 'Publishing Date';
export const MIXPANEL_PWA_INSTALLATION = 'PWA Installation';
export const MIXPANEL_PWA_POPUP_CTA_INSTALL = 'Install';
export const MIXPANEL_PWA_POPUP_CTA_CANCEL = 'Cancel';
export const MIXPANEL_RAIL = 'Rail';
export const MIXPANEL_QWIKCILVER = 'Qwikcilver';
export const MIXPANEL_RAIL_CONTENT_LISTING = 'Rail Content Listing';
export const MIXPANEL_RECENT = 'recent';
export const MIXPANEL_RECURRING_TRANSACTION_NUMBER =
  'Recurring Transaction Number';
export const MIXPANEL_REGISTER = 'Register';
export const MIXPANEL_REGISTRATION = 'Registration';
export const MIXPANEL_REGISTRATION_SCREEN = 'Registration screen';
export const MIXPANEL_REGISTRING_COUNTRY = 'Registring Country';
export const MIXPANEL_REMOVE_ALL = 'Remove All';
export const MIXPANEL_RENTAL_EXPIRY_DATE = 'Rental Expiry Date';
export const MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE =
  'Rental Purchase Exipry Date';
export const MIXPANEL_RENTAL_PURCHASE_DATE = 'Rental Purchase Date';
export const MIXPANEL_RENTAL_RELEASE_DATE = 'Rental Release Date';
export const MIXPANEL_RESEND_OTP = 'Resend OTP';
export const MIXPANEL_RESET_SETTINGS_TO_DEFAULT = 'Reset Settings to default';
export const MIXPANEL_RESULTS_RETURNED = 'Results Returned';
export const MIXPANEL_RIBBON = 'Ribbon';
export const MIXPANEL_RIGHT_ARROW = 'right-arrow';
export const MIXPANEL_RIGHT = 'Right';
export const MIXPANEL_RIBBON_NAME = 'Ribbon Name';
export const MIXPANEL_SEARCH = 'Search';
export const MIXPANEL_SEARCH_QUERY = 'Search Query';
export const MIXPANEL_SEARCH_SUCCESS = 'Search Success';
export const MIXPANEL_SEARCH_FILTER_TYPE = 'Search filter type';
export const MIXPANEL_SEARCH_TYPE = 'Search Type';
export const MIXPANEL_SEARCH_FILTER_CLEAR = 'Search filter clear';
export const MIXPANEL_NULL_SEARCH = 'Null searches';
export const MIXPANEL_SEARCH_FILTER_CANCEL = 'Search filter cancelled';
export const MIXPANEL_FILTER_PAGE = 'filter page';
export const MIXPANEL_SELECT_BY = 'select_by';
export const MIXPANEL_SEND_OTP = 'Send OTP';
export const MIXPANEL_SERIES = 'Series';
export const MIXPANEL_SESSION_ID = 'Session ID';
export const MIXPANEL_SETTING_CHANGED = 'Setting Changed';
export const MIXPANEL_SHARING_PLATFORM = 'Sharing Platform';
export const MIXPANEL_SIGN_UP_FOR_FREE = 'Sign up for FREE';
export const MIXPANEL_SOCIAL = 'Social';
export const MIXPANEL_SOCIAL_AUTHORIZATION = 'Social';
export const MIXPANEL_SOCIAL_NETWORK = 'Social Network';
export const MIXPANEL_SORT = 'Sort';
export const MIXPANEL_SOURCE = 'Source';
export const MIXPANEL_SUBMIT = 'Submit';
export const MIXPANEL_SUBSCRIBE = 'Subscribe';
export const MIXPANEL_SUBSCRIBE_LOWER_CASE = 'subscribe';
export const MIXPANEL_SUBSCRIBE_NOW = 'Subscribe Now';
export const MIXPANEL_SUBSCRIPTION = 'Subscription';
export const MIXPANEL_SUBTITLE_LANGUAGE = 'Subtitle Language';
export const MIXPANEL_SUBTITLES = 'Subtitles';
export const MIXPANEL_SUCCESS = 'Success';
export const MIXPANEL_SUBSCRIPTION_PLAN_PAGE = 'Subscription Plan Page';
export const MIXPANEL_SUBSCRIPTION_STATUS = 'Subscription Status';
export const MIXPANEL_STATE = 'State';
export const MIXPANEL_STREAMING_VIDEOS_QUALITY = 'Streaming Videos Quality';
export const MIXPANEL_SKIPPABLE = 'Skippable';
export const MIXPANEL_SVOD = 'SVoD';
export const MIXPANEL_TAB = 'Tab';
export const MIXPANEL_TAB_NAME = 'Tab Name';
export const MIXPANEL_TABS_HEADER = 'Tabs Header';
export const MIXPANEL_TALAMOOS_MODELNAME = 'Talamoos_modelName';
export const MIXPANEL_MODEL_NAME = 'Model Name';
export const MIXPANEL_MODEL_ORIGIN = 'Model Origin';
export const MIXPANEL_TALAMOOS_ORIGIN = 'Talamoos_origin';
export const MIXPANEL_TALAMOOS_CLICKID = 'Talamoos_clickID';
export const MIXPANEL_TALAMOOS_VERTICAL_INDEX = 'Talamoos Vertical Index';
export const MIXPANEL_TELCO_PAYMENT = 'Telco Payment';
export const MIXPANEL_TERMS_OF_SERVICE = 'Terms of Service';
export const MIXPANEL_TERMS_OF_SERVICES = 'Terms of Services';
export const MIXPANEL_TERMS_OF_USE = 'Terms of Use';
export const MIXPANEL_TEXT = 'text';
export const MIXPANEL_TIME_BASED_90SEC = '90seconds';
export const MIXPANEL_TOAST_MESSAGE = 'Toast Message';
export const MIXPANEL_TOP_BANNER = 'Top Banner';
export const MIXPANEL_TOP_CATEGORY = 'Top Category';
export const MIXPANEL_TRANSACTION_CURRENCY = 'Transaction Currency';
export const MIXPANEL_TWITTER = 'Twitter';
export const MIXPANEL_UNIQUE_ID = 'Unique ID';
export const MIXPANEL_PROFILE_UPDATE = 'Profile Update';
export const MIXPANEL_UPDATE = 'Update Browser';
export const MIXPANEL_UPDATE_PROFILE_EMAIL =
  'Profile Update (with email field)';
export const MIXPANEL_UPDATE_PROFILE_PHONE_NUMBER =
  'Profile Update (with phone number field)';
export const MIXPANEL_UPDATE_PROFILE_EMAIL_PHONE_NUMBER =
  'Profile Update (with email & phone number field)';
export const MIXPANEL_UPGRADE = 'Upgrade';
export const MIXPANEL_UPGRADE_LOWER_CASE = 'upgrade';
export const MIXPANEL_UPGRADE_PLAN = 'Upgrade Plan';
export const MIXPANEL_USERNAME = 'Username';
export const MIXPANEL_USER_TYPE = 'User Type';
export const MIXPANEL_VERIFY = 'Verify';
export const MIXPANEL_VERTICAL_INDEX = 'Vertical Index';
export const MIXPANEL_VIDEO_AUTOPLAYED = 'Video Autoplayed';
export const MIXPANEL_VIEW_IN_ZEE5_APP = 'View in ZEE5 App';
export const MIXPANEL_VOICE = 'voice';
export const MIXPANEL_WHATSAPP = 'Whatsapp';
export const MIXPANEL_WATCHLIST = 'Watchlist';
export const MIXPANEL_YOUTUBE = 'Youtube';
export const MIXPANEL_YES = 'Yes';
export const MIXPANEL_EXTERNAL_LINK = 'External Link';
export const MIXPANEL_NUTS_VALUE = 'NUTS Value';
export const MIXPANEL_SORTING_ORDER = 'Sorting Order';
export const MIXPANEL_GENRE_FILTER = 'Genre Filter';
export const MIXPANEL_LANGUAGE_FILTER = 'Language Filter';
export const MIXPANEL_DONT_CANCEL = "Don't Cancel";
export const MIXPANEL_YES_CANCEL = 'Yes, Cancel';
export const MIXPANEL_RETRY_PACK_POPUP_NAME = 'Retry pack listing';
export const MIXPANEL_PAYMENT_FAILURE = 'Payment Failure';
export const MIXPANEL_RETRY_PAYMENT_PACK =
  'Retry payment for {{INR_Label}} {{amount}}';
export const MIXPANEL_RETRY_PAYMENT_BUTTON = 'Retry Payment';
export const MIXPANEL_CLICK_HERE = 'click here';
export const MIXPANEL_WIFI_ELIGIBLITY = 'WiFi Eligibility';
export const MIXPANEL_RENTAL = 'Rental';
export const MIXPANEL_LEARN_MORE_PLEX = 'LearnMore Plex';
export const MIXPANEL_PLEASE_NOTE_PLEX = 'PleaseNote Plex';
export const MIXPANEL_PLEX_VALIDITY = 'Plex Validity';
export const MIXPANEL_PLEX = 'plex';
export const MIXPANEL_DISPLAY_LANGUAGE = 'Display Language';
export const MIXPANEL_CONTENT_LANGUAGE = 'Content Language';
export const MIXPANEL_IPML = 'IPML';
export const MIXPANEL_BANK_NAME = 'payment_issuer';
export const MIXPANEL_CARD_TYPE = 'Card Type';
export const MIXPANEL_WIDGET = 'Widget';
export const MIXPANEL_WIDGET_NAME = 'Widget Name';
export const MIXPANEL_COMBO_OFFER_WIDGET = 'Combo Offer Widget';
export const MIXPANEL_UPGRADE_COMBO = 'Upgrade Combo';
export const MIXPANEL_KNOW_MORE = 'Know More';
export const MIXPANEL_DEVICE_LIMIT = 'Device Limit';
export const MIXPANEL_DISMISS = 'Dismiss';
export const MIXPANEL_COUNTRY = 'Country';
export const MIXPANEL_ZEE5_COUNTRY = 'Zee5 Country';
export const MIXPANEL_REGION = 'Region';
export const MIXPANEL_CITY = 'City';
export const MIXPANEL_COPY_LINK = 'Copy Link';
export const MIXPANEL_TEXT_MANUAL = 'Text_manual';
export const MIXPANEL_TEXT_SUGGESTION = 'Text_suggestion';
export const MIXPANEL_TEXT_HISTORY = 'Text_history';
export const MIXPANEL_RECENT_SEARCH_QUERY_DISPLAYED =
  'Recent Search Query Displayed';
export const MIXPANEL_MANDATORY_REGISTRATION_SPLIT =
  'Mandatory Registration Split';
export const MIXPANEL_AGE_GROUP = 'Age Group';
export const MIXPANEL_CONSUMPTION_BUY_PLAN = 'Consumption Buy Plan';
export const MIXPANEL_CONSUMPTION_SUBSCRIPTION = 'Consumption Subscription';
export const MIXPANEL_GET_STATRED_WITH_MOBILE = 'Get Started with Mobile';
export const MIXPANEL_VERIFY_MOBILE_OTP = 'Verify Mobile OTP';
export const MIXPANEL_VERIFY_YOUR_ACCOUNT = 'Verify your account';
export const MIXPANEL_GET_STATRED_WITH_EMAIL = 'Get Started with Email';
export const MIXPANEL_ENTER_EMAIL_PASSWORD = 'Enter Email Password';
export const MIXPANEL_EMAIL_VERIFICATION = 'Email Verification';
export const MIXPANEL_TRUECALLER_REGISTRATION = 'Truecaller registration';
export const MIXPANEL_MANUAL_MOBILE_NUMBER_REGISTRATION =
  'Manual mobile number registration';
export const MIXPANEL_MANUAL_EMAIL_REGISTRATION = 'Manual email registration';
export const MIXPANEL_EXISTING_USER_CONFIRMATION = 'Existing user confimation';
export const MIXPANEL_INTIAL_LANDING = 'Intial landing';
export const MIXPANEL_TRUECALLER = 'Truecaller';
export const MIXPANEL_MANUAL_MOBILE = 'Manual mobile';
export const MIXPANEL_MANUAL_EMAIL = 'Manual email';
export const MIXPANEL_ENTER_EXISTING_EMAIL = 'Enter Existing Email address';
export const MIXPANEL_LINK_ACCOUNT = 'Link account';
export const MIXPANEL_CONFIRMATION_SCREEN = 'Confirmation Screen';
export const MIXPANEL_LINK_TO_EXISTING_ACCOUNT = 'link to existing account';
export const MIXPANEL_ENTER_EXISTING_EMAIL_PASSWORD =
  'Enter Existing Email Password';
export const MIXPANEL_SEND_VERIFICATION_LINK_INSTEAD =
  'Send Verification Link Instead';
export const MIXPANEL_SEND_VERIFICATION_LINK_MANUALLY =
  'Send Verification Link Manually';
export const MIXPANEL_EDIT_EMAIL = 'Edit Email';
export const MIXPANEL_VERIFICATION_OF_EXISTING_EMAIL_SENT =
  'Verification of Existing Email sent';
export const MIXPANEL_VERIFY_OTP = 'Verify OTP';
export const MIXPANEL_ENTER_EXISTING_MOBILE_OTP = 'Enter Existing Mobile OTP';
export const MIXPANEL_TRY_AGAIN_WITH_OTP = 'Try again with OTP';
export const MIXPANEL_EXISTING_OTP_RESEND = 'Existing OTP resend';
export const MIXPANEL_USE_PASSWORD_INSTEAD = 'Use Password Instead';
export const MIXPANEL_LINK_EXISTING_MOBILE = 'Link existing mobile';
export const MIXPANEL_LINK_ACCOUNT_METHOD = 'Link account method';
export const MIXPANEL_EDIT_MOBILE_NO = 'Edit Mobile Number';
export const MIXPANEL_LINK_ACCOUNT_CONFIRMATION = 'Link Account Confirmation';
export const MIXPANEL_ON_BOARDING_JOURNEY = 'On Boarding Journey';
export const MIXPANEL_LINK_BY_MOBILE = 'Link by Mobile';
export const MIXPANEL_ORDER_SUMMARY = 'Order Summary';
export const MIXPANEL_VOICE_ERROR_MESSAGE = 'Error message';
export const MIXPANEL_CONSUMPTION_UPGRADE_PLAN = 'Consumption Upgrade Plan';
export const MIXPANEL_PAYMENT_FAILED = 'Payment Failed';
export const MIXPANEL_IS_SUBSCRIPTION_FLOW = 'IsSubscriptionFlow';
export const MIXPANEL_SKIP = 'skip';
export const MIXPANEL_PARENTAL_CONTROL = 'parental control';
export const MIXPANEL_PARENTAL_CONTROL_SETTINGS = 'Parental control settings';
export const MIXPANEL_APPSFLYER_ID = 'Appsflyer ID';
export const MIXPANEL_TYPE = 'type';
export const MIXPANEL_PAYMENT_JOURNEY = 'Payment Journey';
export const MIXPANEL_APP_ARP_USER = 'App User';
export const MIXPANEL_PWA_APP_VERSION = 'PWA App Version';
export const MIXPANEL_NEW_SUBSCRIPTION = 'New subscription';
export const MIXPANEL_RENEWAL_SUBSCRIPTION = 'Renewal subscription';
export const MIXPANEL_NETWORK_POPUP = 'Network Popup';
export const MIXPANEL_POPUP_LAUNCH = 'Popup Launch';
export const MIXPANEL_DEBUG_STEP = 'Debug Step';
export const MIXPANEL_Retry = 'Retry';
export const MIXPANEL_CLOSE = 'Close';
export const MIXPANEL_WATCH_TRAILER = 'Watch Trailer';
export const MIXPANEL_GOOGLE_LOGIN = 'google';
export const MIXPANEL_FACEBOOK_LOGIN = 'facebook';
export const MIXPANEL_TWITTER_LOGIN = 'twitter';
export const MIXPANEL_APPLE_LOGIN = 'apple';
export const MIXPANEL_ADD_WATCHLIST = 'Added to Watchlist';
export const MIXPANEL_REMOVE_WATCHLIST = 'Removed from Watchlist';
export const MIXPANEL_LOGIN_WITH_ZEE5 = 'Login with ZEE5';
export const MIXPANEL_VI_TVOD_BLOCKER_POPUP = 'Vi Tvod Blocker Popup';
export const MIXPANEL_PAUSE_BUY_PLAN = 'Pause Nudge Buy Plan';
export const MIXPANEL_AGGREGATOR_PARTNER_NAME = 'Aggregator Partner Name';
export const MIXPANEL_AGGREGATOR_PARTNER_ID = 'Aggregator Partner ID';
export const MIXPANEL_AGGREGATOR_USER_TYPE = 'Aggregator User Type';
export const MIXPANEL_ACTIVE_PARTNER_SUBSCRIPTION =
  'Active Partner Subscriptions';
export const MIXPANEL_CONTENT_OWNER = 'Content Owner';
export const MIXPANEL_BUY_PLAN = 'Buy Plan';
export const MIXPANEL_SUBSCRIBED = 'Subscribed';
export const MIXPANEL_NOT_SUBSCRIBED = 'Not Subscribed';
export const MIXPANEL_LIKE_DISLIKE_TOGGLE = 'Toggle';
export const MIXPANEL_LATITUDE = 'Latitude';
export const MIXPANEL_LONGITUDE = 'Longitude';
export const MIXPANEL_IP = 'IP';
export const MIXPANEL_IS_EMAIL_PRESENT = 'Is_email_present';
export const MIXPANEL_IS_MOBILE_PRESENT = 'is_mobile_Present';
export const MIXPANEL_WEB_SERIES = 'Web Series';
export const MIXPANEL_TV_SHOWS = 'TV Shows';
export const MIXPANEL_MOVIES = 'Movies';
export const MIXPANEL_TVOD = 'tvod';
export const MIXPANEL_NAVIGATION_PROPERTY = 'Navigation Property';
export const MIXPANEL_SPORTS_ILT20 = 'Sports ILT20';
export const MIXPANEL_QUERY_ID = 'Query ID';
export const MIXPANEL_OPEN_ZEE5_APP = 'Open ZEE5 App';
export const MIXPANEL_PAYMENT_SUCCESS_APR = 'payment_success';
export const MIXPANEL_MORE = 'More';
export const MIXPANEL_AGGREGATOR_HOME_PAGE = 'Aggregator Home Page';
export const MIXPANEL_PIN_SCOREBOARD = 'Pin Scoreboard';
export const MIXPANEL_PIN = 'Pin';
export const MIXPANEL_UNPIN = 'Unpin';
export const MIXPANEL_SCORE_CLICK = 'Score Click';
export const MIXPANEL_SEARCH_LANDING = 'Search Landing';
export const MIXPANEL_NO_KEYWORD = 'No Keyword';
export const MIXPANEL_RAIL_CONTENT_LISTING_ID = 'Rail Content Listing ID';
export const MIXPANEL_CONTENT_COUNT = 'Content Count';
export const MIXPANEL_CAROUSAL_SLOT_ID = 'Carousal slot ID';
export const MIXPANEL_MODEL_ID = 'Model ID';
export const MIXPANEL_NO_MODEL_SERVED = 'No Model Served';
export const MIXPANEL_EVENTS_SEARCH_THUMBNAIL_CLICK = 'Search Thumbnail Click';
export const MIXPANEL_EVENTS_SEARCH_RAIL_IMPRESSION = 'Search Rail Impression';
export const MIXPANEL_SELECTION_SOURCE = 'Selection_Source';
